import React from "react";
import { css } from "@emotion/react";
import { FaQuestionCircle } from "react-icons/fa";

const numberFormat = new Intl.NumberFormat().format;
const percentFormat = new Intl.NumberFormat(undefined, { style: "percent", signDisplay: "always" })
    .format;

export default function BigMetric({
    name,
    range,
    help,
    openModal,
    region,
    value,
    prevValue,
    nometric,
    nogrowth,
    visible = true
}) {
    if (!visible) return "";
    return (
        <div
            css={css`
                display: grid;
                justify-items: center;
                padding: 0.5rem;
            `}
        >
            <div
                css={css`
                    font-size: 0.7rem;
                    text-transform: uppercase;
                    font-weight: 400;
                `}
            >
                {range}
            </div>
            <div
                css={css`
                    font-weight: 700;
                `}
            >
                {name}{" "}
                <FaQuestionCircle
                    onClick={openModal(
                        `${range} ${/Recent Episodes/.test(region) ? "" : region} ${name}`,
                        help,
                        region
                    )}
                    css={css`
                        cursor: pointer;
                        opacity: 0.7;
                        transition: opacity 0.1s;
                        font-size: 0.7rem;
                        &:hover {
                            opacity: 1;
                        }
                    `}
                />
            </div>
            <div
                css={css`
                    font-size: 0.9rem;
                    margin: 0.1rem 0;
                `}
            >
                {region}
            </div>
            {nometric ? null : (
                <div
                    css={css`
                        font-size: 2rem;
                    `}
                >
                    {value !== undefined ? numberFormat(value) : "\u00A0"}
                </div>
            )}
            {nogrowth ? null : (
                <div
                    css={css`
                        font-size: 0.8rem;
                    `}
                >
                    <GrowthSpan value={value} prevValue={prevValue}>
                        month/month
                    </GrowthSpan>
                </div>
            )}
        </div>
    );
}

const epsilon = 0.01;

function GrowthSpan({ value, prevValue, children }) {
    if (!prevValue) return "\u00A0";

    let growth = (value - prevValue) / prevValue;
    if (Math.abs(growth) < epsilon) growth = 0;

    const msg = percentFormat(growth);

    return (
        <span
            css={css`
                color: ${growth > 0 ? "#0a0" : "#888"};
                font-weight: 500;
            `}
        >
            {msg} {children}
        </span>
    );
}
